<script setup lang="ts">
import Completed from "@/views/playground/planner/business-management/settlement-management/Completed.vue";
</script>

<template>
  <completed></completed>
</template>

<style scoped></style>
